import { handleError } from "../../components/Utils/Utils";
import MyIncomeService from "./service";

export const getWillRelease = (store, value) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  return MyIncomeService.getWillReleaseData(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const lastPage = false;
      const status = data.message;
      store.setState({
        isLoading,
        data,
        header: response.headers,
        lastPage,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getWillReleaseList = (store, value) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  MyIncomeService.getWillReleaseData(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;
      store.state.data = store.state.data.concat(data);
      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getHasRelease = (store, value) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  return MyIncomeService.getHasReleaseData(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const lastPage = false;
      const status = data.message;
      store.setState({
        isLoading,
        data,
        headerHasRelease: response.headers,
        lastPage,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};
export const getHasReleaseList = (store, value) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  MyIncomeService.getHasReleaseData(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;
      store.state.data = store.state.data.concat(data);
      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        headerHasRelease: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};
export const getReciveData = async (store, value) => {
  try {
    let totalAmount = await MyIncomeService.getReciveTotalAmount({
      cancel: false,
      completed: true,
    });
    let saldo = await MyIncomeService.getReciveSaldoData(value);
    let rekening = await MyIncomeService.getMyRekening();

    store.setState({
      saldo: saldo.data,
      total_amount: totalAmount.data,
      rekening: rekening.data,
    });
  } catch (error) {
    console.log(error);
    handleError(error);
  }
};
